<template>
  <div class="col-md-12 grid-margin strech-card">
    <div class="card">
      <div
        class="card-body"
        v-if="isLogged"
      >
        <div class="row mb-4">
          <div class="col-md-6">
            <h3 class="font-weigth-bold">
              {{
                lista === ListaTypes.REGISTRO
                  ? 'Solicitudes de registro de usuarios'
                  : 'Solicitudes de modificación de usuarios'
              }}
            </h3>
          </div>
          <div class="col-md-6"></div>
        </div>
        <div class="white-content-general mb-4">
          <div class="row">
            <div class="col-md-4">
              <p class="lh-m mb-0"></p>
            </div>
            <div class="col-md-8">
              <button
                @click="cambiarLista"
                class="btn btn-primary btn-general float-right"
              >
                {{ lista === ListaTypes.REGISTRO ? 'Solicitudes de modificación' : 'Solicitudes de registro' }}
              </button>
            </div>
          </div>
        </div>
        <div v-if="lista === ListaTypes.REGISTRO">
          <GestionSolicitudRegistro />
        </div>
        <div v-else>
          <GestionSolicitudModificacion />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GestionSolicitudRegistro from './components/GestionSolicitudRegistro.vue';
import GestionSolicitudModificacion from './components/GestionSolicitudModificacion.vue';
import { ListaTypes } from '@/store/modules/solicitudRegistro';

export default {
  name: 'SolicitudRegistro',
  components: {
    GestionSolicitudRegistro,
    GestionSolicitudModificacion,
  },
  data() {
    return {
      ListaTypes,
    };
  },
  created() {},
  mounted() {},
  methods: {
    cambiarLista() {
      if (this.lista === ListaTypes.REGISTRO) {
        this.$store.commit('solicitudRegistro/setLista', ListaTypes.MODIFICACION);
      } else {
        this.$store.commit('solicitudRegistro/setLista', ListaTypes.REGISTRO);
      }
    }
  },
  computed: {
    isLogged() {
      return this.$store.getters['auth/isLogged'] ? this.$store.getters['auth/isLogged'] : false;
    },
    rol() {
      if (!this.$store.state.auth.rol) {
        return;
      }
      return this.$store.state.auth.rol;
    },
    lista() {
      return this.$store.getters['solicitudRegistro/lista']
        ? this.$store.getters['solicitudRegistro/lista']
        : '';
    },
  },
};
</script>
